import { AUDIT_ENGAGEMENT_ID_QUERY_PARAM } from "PFApp/audit_planner/audit_planner.utils";
import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { Modal } from "PFComponents/modal";
import { Typography } from "PFComponents/typography";
import { useActivityDelete } from "PFCore/hooks/queries/activity/use_activity_delete";
import { Activity } from "PFTypes";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { startsWith } from "underscore.string";

type RemoveConfirmModalProps = {
  activity: Activity;
  isAudit: boolean;
  onClose: () => void;
};

export const RemoveConfirmModal = ({ activity, isAudit, onClose }: RemoveConfirmModalProps) => {
  const { t } = useTranslation("core");
  const navigate = useNavigate();
  const location = useLocation();
  const { showGrowl } = useGrowlStoreActions();

  const { mutateAsync: deleteActivity } = useActivityDelete();

  return (
    <Modal
      title={t("activityActions.deleteActivity")}
      onOK={() => {
        deleteActivity({
          activityId: activity.id,
          parentActivityId: activity.parent_activity_id ?? undefined
        }).then(
          () => {
            showGrowl({ message: t("activityActions.destroySuccess") });
            if (isAudit) {
              const queryParams = new URLSearchParams({
                [AUDIT_ENGAGEMENT_ID_QUERY_PARAM]: `${activity.parent_activity_id}`
              });
              navigate(
                activity.parent_activity_id ? `/audit_planner?${queryParams.toString()}` : "/audit_planner"
              );
            } else if (startsWith(location.pathname, "/activities")) {
              navigate("/");
            }
          },
          (resp) => {
            const msg =
              resp.status === 404 ? "activityActions.destroyFail_404" : "activityActions.destroyFail";
            showGrowl({ message: t(msg), kind: "error" });
          }
        );
      }}
      onClose={onClose}
      kindOK="danger"
    >
      <Typography variant="bodyRegular">{t("activityActions.confirmDelete")}</Typography>
    </Modal>
  );
};
